import $ from 'jquery';
import Cookies from 'js-cookie';
window.$ = window.jQuery = $;

function emailCookieCollision() {
	
	//Mobile - stack pop-overs
	if ($('#email-pop-over').length && $('#cookies').is(':visible') && $(document).width() < 768) {
		var cookie_height = $('#cookies').outerHeight() + 28;
		$('#email-pop-over').css('bottom',cookie_height);		
	}
	
	//Desktop - do not stack pop-overs.
	if ($('#email-pop-over').length && $(document).width() >= 768) {
		$('#email-pop-over').css('bottom',14);		
	}
	
}

function showEmailPopUp() {
	
	var fade = 6000;
	
	if($('#email-pop-over').length) {
	
		//Show Modal after 6 seconds
		setTimeout(function() {
			
			emailCookieCollision();	
			$('#email-pop-over').removeClass("pop-over-in-active");
			$('#email-pop-over').addClass("pop-over-active");	
			$('#email-pop-over').fadeTo("slow",1);
			
		}, fade);
		
		//Close Modal
		$('.email-pop-over-close').click(function() {
			
			var days = 14;
			if ($(this).data('days')) {
				days = $(this).data('days');
			}
			
			$('#email-pop-over').hide();
			Cookies.set('mailing_list', 'hide', { expires: days });
			
		});
		
	}
	
}

function emailSignUpResponse(sign_up_id,action,msg = '') {
	
	var sign_up_div = "#" + sign_up_id;
	var confirmation_div = sign_up_div + ".mailchimp-sign-up .mailchimp-sign-up-confirmation";
	
	//hide all the child elements
	$('form',sign_up_div).children().hide();
	$(sign_up_div).children().hide();
	
	//Set the defaults for confirmation area
	$(confirmation_div).show();
	$('.confirmation-icon',confirmation_div).hide();
	$('.mailchimp-sign-up-confirmation-feedback .feedback',confirmation_div).hide();
	$('.mailchimp-sign-up-confirmation-feedback .message',confirmation_div).html(msg);
	
	//Open Links from MailChimp in new window
	$('.mailchimp-sign-up-confirmation-feedback .message a',confirmation_div).click(function(){
		window.open(this.href);
		return false;
	});
	
	//Show the appropriate confirmation
	if(action == 'submit') {
		$('.submit',confirmation_div).show();
	}
	if(action == 'error') {
		$('.error',confirmation_div).show();
	}
	if(action == 'success') {
		$('.success',confirmation_div).show();
	}
	
	if($('#email-pop-over').length) {
		
		var days = 14;
		var fade = 3000;
		
		if(action == 'error') {
			$('.close',confirmation_div).show();
		}
		
		if(action == 'success') {
			$('.close',confirmation_div).show();
			days = 365;
			fade = 4000;
		}
		
		if(action == 'error' || action == 'success') {
			
			//Show Modal after 6 seconds
			setTimeout(function() {	
				if ($('#email-pop-over').is(':visible')) {
					$('#email-pop-over').fadeOut("slow");
					Cookies.set('mailing_list', 'hide', { expires: days });
				}
			}, fade);
			
		}
	
	}
	
} 

$(document).ready( function () {
	
	var forms = $('form.sign-up-json');
		
	if ( forms.length > 0 ) {
		
		forms.each(function( index ) {
			
			var form = this;
			
			//in the case of multiple forms lets try to tell them apart
			var sign_up_id = "mailchimp-subscribe-" + index;
			$(form).parent().attr('id',sign_up_id);
			var sign_up_div = "#" + sign_up_id;
			
			//Give some height
			$(sign_up_div).css("height", Math.ceil($(sign_up_div).height()));
			if ($(sign_up_div).hasClass("mailchimp-sign-up-single-line")) {
				$('form',sign_up_div).css("height", Math.ceil($('form',sign_up_div).height()));
			}
			
			$('.button',this).bind('click', function ( event ) {
				if ( event ) event.preventDefault();
				register(form);
				
			});
		  
		});		

	}
	
	if($('#email-pop-over').length) {
		
		var pop_over_sign_up_id = $("#email-pop-over .mailchimp-sign-up").attr('id');
		
		$('.close-mailing-list-modal').click(function () {
			var action = $(this).data('action');
			
			emailSignUpResponse(pop_over_sign_up_id,action);
		});
		
	}
	
});

function register(form) {
	
	var sign_up_id = $(form).parent().attr('id');
	emailSignUpResponse(sign_up_id,'submit');
	
	$.ajax({
		type: $(form).attr('method'),
		url: $(form).attr('action'),
		data: $(form).serialize(),
		cache       : false,
		dataType    : 'json',
		contentType: "application/json; charset=utf-8",
		error       : function(err) {
			emailSignUpResponse(sign_up_id,'error');
		},
		success     : function(data) {
			
			var msg = data.msg;
			
			if (data.result != "success") {
				
				if (msg.indexOf("is already subscribed to list") >= 0) {
					emailSignUpResponse(sign_up_id,'success',data.msg);
				} else {
					emailSignUpResponse(sign_up_id,'error',data.msg);
				}
				
			} else {
				emailSignUpResponse(sign_up_id,'success',data.msg);
			}

		}
	});
}

$(document).ready(showEmailPopUp);
$(window).resize(emailCookieCollision); 